import { Radio, ScanLine } from "lucide-react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-cyanx/15 bg-black py-12"
    >
      <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-6 px-6 sm:px-10">
        <div>
          <p className="title-tall">
            <span className="crt-text block font-poster text-4xl leading-none">GUMZ</span>
          </p>
          <p className="mt-1 font-mono text-[10px] tracking-[0.3em] text-mute">
            EST. 2026 // LAST TRAIN DEPOT
          </p>
        </div>
        <div className="flex items-center gap-6 font-mono text-[10px] tracking-[0.3em] text-fog">
          <span className="flex items-center gap-2">
            <Radio size={12} className="text-cctv" /> ALL SIGNALS MONITORED
          </span>
          <span className="hidden items-center gap-2 sm:flex">
            <ScanLine size={12} className="text-cyanx" /> CAM NETWORK ACTIVE
          </span>
        </div>
        <div className="flex flex-col items-end gap-2 font-mono text-[10px] tracking-[0.25em] text-mute">
          <p>© 2026 GUMZ TRANSIT AUTHORITY</p>
          <div className="flex gap-4">
            <Link to="/impressum" className="hover:text-cyanx transition-colors">IMPRESSUM</Link>
            <Link to="/privacy" className="hover:text-cyanx transition-colors">PRIVACY</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
